import React from 'react';
import PropTypes from 'prop-types';
import NamedLink from '../NamedLink/NamedLink';
import { useSelector } from 'react-redux';

import css from './MainTabNavVertical.module.css';
import IconDashboard from '../IconDashboard/IconDashboard';
import IconMentors from '../IconMentors/IconMentors';
import IconMessages from '../IconMessages/IconMessages';
import { getIsMentor } from '../../util/userUtil';

const TabIcon = props => {
  const { id, icon, selected = false, linkProps } = props;

  return (
    <NamedLink {...linkProps}>
      <div id={id} className={selected ? css.tabRootSelected : css.tabRoot}>
        {icon}
      </div>
    </NamedLink>
  );
};

const { arrayOf, bool, node, object, string } = PropTypes;

TabIcon.propTypes = {
  id: string.isRequired,
  className: string,
  text: node.isRequired,
  disabled: bool,
  selected: bool,
  linkProps: object.isRequired,
};

const MainTabNavVertical = props => {
  const { tab, currentUser } = props;
  const notificationCount = useSelector(state => state.user.currentUserNotificationCount || 0);

  const isMentor = getIsMentor(currentUser);
  const tabs = [
    {
      icon: <IconDashboard selected={tab === 'dashboard'} />,
      selected: tab === 'dashboard',
      linkProps: {
        name: 'DashboardPage',
      },
    },
    {
      icon: <IconMentors selected={tab === 'search'} />,
      selected: tab === 'search',
      linkProps: {
        name: 'SearchPage',
      },
    },
    {
      icon: (
        <span className={css.iconWrap}>
          <IconMessages selected={tab === 'inbox'} />
          {notificationCount > 0 ? <span className={css.dot} /> : null}
        </span>
      ),
      selected: tab === 'inbox',
      linkProps: {
        name: 'InboxPage',
        params: { tab: isMentor ? 'sales' : 'orders' },
      },
    },
  ];

  return (
    <div className={css.root}>
      <nav className={css.tabsContainer}>
        {tabs.map((tab, index) => {
          const id = typeof tab.id === 'string' ? tab.id : `${index}`;
          return <TabIcon key={id} id={id} {...tab} />;
        })}
      </nav>
    </div>
  );
};

MainTabNavVertical.propTypes = {
  className: string,
  rootClassName: string,
  tabRootClassName: string,
  tabs: arrayOf(object).isRequired,
};

export default MainTabNavVertical;
